// ============================================
// API CONFIGURATION - SIRF YAHAN URL CHANGE KARO
// ============================================
// const BASE_URL = "http://127.0.0.1:8000/api/yashvitech";
const BASE_URL = "https://priyanshi.coalfeed.in/api/yashvitech";
// ============================================
// TOKEN HELPERS
// ============================================
export const getAccessToken = () => localStorage.getItem("access_token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");

export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem("access_token", accessToken);
  localStorage.setItem("refresh_token", refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
};

export const setUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const isAuthenticated = () => {
  return getAccessToken() !== null;
};

// ============================================
// AUTH HEADER HELPER
// ============================================
const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getAccessToken()}`,
});

// ============================================
// API METHODS
// ============================================

// ---------- PUBLIC ----------

// Contact Form Submit (Landing Page)
export const submitContact = async (data) => {
  const response = await fetch(`${BASE_URL}/contact/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response.json();
};

// ---------- AUTH ----------

// Login
export const loginUser = async (email, password) => {
  const response = await fetch(`${BASE_URL}/login/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return response.json();
};

// Logout
export const logoutUser = async () => {
  try {
    const refreshToken = getRefreshToken();
    const response = await fetch(`${BASE_URL}/logout/`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    return response.json();
  } catch (error) {
    console.error("Logout error:", error);
    return { status: "error" };
  }
};

// ---------- PROTECTED (Dashboard) ----------

// Dashboard Stats
export const getDashboardStats = async () => {
  const response = await fetch(`${BASE_URL}/dashboard/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};

// Profile
export const getProfile = async () => {
  const response = await fetch(`${BASE_URL}/profile/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};

// Enquiries List
export const getEnquiries = async () => {
  const response = await fetch(`${BASE_URL}/enquiries/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};

// Single Enquiry Detail
export const getEnquiryDetail = async (id) => {
  const response = await fetch(`${BASE_URL}/enquiries/${id}/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};

// Update Enquiry (PATCH)
export const updateEnquiry = async (id, data) => {
  const response = await fetch(`${BASE_URL}/enquiries/${id}/`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  return response.json();
};

// Delete Enquiry
export const deleteEnquiry = async (id) => {
  const response = await fetch(`${BASE_URL}/enquiries/${id}/`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  return response.json();
};



// ============================================
// PRODUCT ENQUIRY — Add these to api.js
// ============================================

// ---------- PUBLIC ----------

// Submit product enquiry (form se)
export const submitProductEnquiry = async (data) => {
  const response = await fetch(`${BASE_URL}/product-enquiry/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response.json();
};

// ---------- ADMIN (Protected) ----------

// Get all product enquiries
export const getProductEnquiries = async () => {
  const response = await fetch(`${BASE_URL}/product-enquiries/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};

// Get single product enquiry
export const getProductEnquiryDetail = async (id) => {
  const response = await fetch(`${BASE_URL}/product-enquiries/${id}/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};

// Update product enquiry (is_read / is_replied)
export const updateProductEnquiry = async (id, data) => {
  const response = await fetch(`${BASE_URL}/product-enquiries/${id}/`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  return response.json();
};

// Delete product enquiry
export const deleteProductEnquiry = async (id) => {
  const response = await fetch(`${BASE_URL}/product-enquiries/${id}/`, {
    method: "DELETE",
    headers: authHeaders(),
  });

  if (response.status === 204) {
    return { status: "success" };
  }
  return response.json();
};

// Get stats
export const getProductEnquiryStats = async () => {
  const response = await fetch(`${BASE_URL}/product-enquiries/stats/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return response.json();
};